var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 330 330",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    stroke: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_495_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_496_",
    x: 170,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_497_",
    x: 90,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_498_",
    x: 50,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_500_",
    x: 130,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_501_",
    x: 250,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_502_",
    x: 210,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_503_",
    d: "M150,115.4c0-41.36-33.646-75.009-75.001-75.009C33.644,40.391,0,74.04,0,115.4 c0,67.33,64.064,109.981,66.792,111.764c2.493,1.629,5.35,2.444,8.207,2.444c2.857,0,5.714-0.815,8.207-2.444 c0.357-0.233,8.859-5.825,19.522-15.76C124.294,191.316,150,158.354,150,115.4z M82.28,189.454 c-2.652,2.471-5.13,4.608-7.294,6.386C60.051,183.593,30,154.133,30,115.4c0-24.818,20.186-45.009,44.999-45.009 C99.812,70.391,120,90.582,120,115.4C120,147.565,99.488,173.424,82.28,189.454z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_506_",
    cx: 75,
    cy: 115.391,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_507_",
    d: "M254.999,40.391C213.644,40.391,180,74.04,180,115.4c0,67.33,64.064,109.981,66.792,111.764 c2.493,1.629,5.35,2.444,8.207,2.444c2.857,0,5.714-0.815,8.207-2.444c0.357-0.233,8.859-5.825,19.523-15.76 C304.294,191.316,330,158.354,330,115.4C330,74.04,296.354,40.391,254.999,40.391z M262.28,189.454 c-2.652,2.471-5.13,4.608-7.294,6.386C240.051,183.593,210,154.133,210,115.4c0-24.818,20.186-45.009,44.999-45.009 C279.813,70.391,300,90.582,300,115.4C300,147.565,279.488,173.424,262.28,189.454z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_510_",
    cx: 255,
    cy: 115.391,
    r: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.ca804c3b0466091b02dcee5934db1674.svg";
export { ForwardRef as ReactComponent };